/* PROJ-98 Gratis-Geschenk ab Warenkorbwert
 * =========================================
 * Komfort-Schicht im Theme. Die PREISWAHRHEIT liegt ausschliesslich im Shopify-Rabatt
 * (Function `gratis-geschenk`, 1 Stueck frei ab Schwelle) — dieses Skript legt nur ein,
 * entfernt und zeigt an. Ein manipulierter Browser bekommt dadurch kein Geschenk.
 *
 * SCHWELLEN-BASIS = Summe der LISTENPREISE (original_line_price) aller versandpflichtigen
 * Zeilen ohne Geschenk, also vor Mengenrabatt und vor Rabattcodes. Dieselbe Zahl rechnet die
 * Function aus `cost.subtotalAmount`; sie steht auch in snippets/gift-state.liquid. Weichen die
 * drei Stellen voneinander ab, zeigt der Balken etwas anderes an, als die Kasse rechnet
 * (Entscheidung Dominik 11.09.2026).
 *
 * Aufgaben:
 *  1. Sitzungs-Merker setzen, wenn der Kunde das Geschenk selbst entfernt ([data-gift-remove])
 *     — die Auswahl selbst passiert seit 13.09.2026 NICHT mehr im Warenkorb: im Modus
 *     „auswahl" fuehrt ein Link-Knopf zur Geschenk-Kollektion (Vorbild Gipfelgaudi), im Modus
 *     „automatisch" legt Aufgabe 5 ein (Vorbild Tierliebhaber). Kacheln und Einlege-Knopf im
 *     Drawer sind weg (sie nahmen im Footer ein Drittel der Hoehe, Dominik 13.09.).
 *  2. Auto-Entfernen, sobald die Basis unter die Schwelle faellt (+ Hinweis)
 *  3. Mehr als eine Geschenk-Zeile auf eine reduzieren (Doppelklick, Browser-Zurueck); eine
 *     Geschenk-Zeile mit Menge > 1 auf Menge 1 kuerzen (Kollektions-/Produktseite)
 *  4. BEZAHLTE Geschenk-Zeilen aufraeumen — greift der Rabatt nicht (deaktiviert, nicht
 *     kombinierbarer Code im Warenkorb, Produkt nicht mehr in der Get-Kollektion), stuende sonst
 *     ein „Geschenk" zum vollen Preis im Warenkorb (Review 11.09.2026)
 *  5. Modus „automatisch": Geschenk ab der Schwelle ohne Klick einlegen; nach bewusstem
 *     Entfernen durch den Kunden in dieser Sitzung nicht erneut. Kostet die eingelegte Zeile
 *     laut Antwort Geld, wird sie sofort zurueckgerollt und die Automatik gesperrt
 *  6. Custom Element <dm-gift-progress> (Zwei-Stufen-Balken) aktuell halten
 *  7. Stillhalten, solange ein Editor eine Zeile ersetzt (PROJ-99 Bearbeiten-Modus, Knopf traegt
 *     data-dl-modus="bearbeiten") — der Zwischenstand „alte + neue Zeile" ist kein Warenkorb
 *  8. STUFEN (PROJ-112, 10.10.2026): bis zu zwei Geschenk-Stufen, jede mit eigener Schwelle und
 *     eigenem Automatik-Produkt (Stufe 1 = cart_gift_auto_handle, Stufe 2 = cart_gift_auto_handle_2).
 *     Welche Stufe eine Geschenk-Zeile ist, entscheidet ihr Produkt-Handle; eine Geschenk-Zeile
 *     mit fremdem Handle gilt als Stufe 1 (Altverhalten, Auswahl-Modus). Die Regeln 2 bis 5
 *     laufen JE STUFE; pro Durchlauf passiert hoechstens eine Aenderung (das Theme-Event danach
 *     loest den naechsten Durchlauf aus). Die Function `gratis-geschenk` rechnet die Stufen
 *     mit denselben Schwellen (Metafeld stufen[]).
 *
 * BETRIEBSREGEL — ABSCHALTEN IN DIESER REIHENFOLGE:
 *   1. Theme-Schalter „Gratis-Geschenk aktivieren" aus
 *   2. DANN den Shopify-Rabatt deaktivieren
 * Andersherum (erst Rabatt aus) kosten Geschenk-Zeilen in offenen Warenkoerben ploetzlich Geld.
 * Solange der Rabatt noch laeuft, bleiben bereits eingelegte 0,00-EUR-Geschenke liegen und werden
 * ausgeliefert — das ist gewollt (versprochen ist versprochen). Weggeraeumt wird nur, was Geld
 * kostet. Dieselbe Regel steht in den Theme-Einstellungen und im Schema von sections/dm-gift-bar.liquid.
 *
 * Konfiguration kommt SERVER-SEITIG aus snippets/gift-picker.liquid (data-Attribute) —
 * keine Betraege, Handles oder Texte in diesem Skript. Der Block rendert als Anker, sobald das
 * Angebot eingeschaltet ist ODER ein Geschenk im Warenkorb liegt — auch bei Basis 0, leerem
 * Bestand oder abgeschaltetem Angebot, denn genau dann muss eine liegengebliebene Geschenk-Zeile
 * noch entfernt werden (Review 11.09.2026).
 *
 * START-FETCH: Der Anker liegt im Cart-Drawer, also auf JEDER Seite. Geprueft wird beim Seitenaufbau
 * nur, wenn Liquid per data-gift-check meldet, dass es etwas zu tun geben kann (Geschenk im
 * Warenkorb, oder Automatik-Modus mit erreichter Schwelle). Sonst kostet das Angebot keinen
 * einzigen Roundtrip. Auf Warenkorb-Ereignisse wird immer geprueft.
 *
 * Re-Render (Muster assets/prio-plus.js): Drawer -> Theme-Event 'cart:refresh'
 * (cart-drawer holt sich selbst frisches Section-HTML, assets/theme.js:4374),
 * Cart-Seite -> Reload. 'cart:change' wird NIE selbst gefeuert — theme.js:4354 erwartet
 * darin gebuendelte Sections und wirft sonst.
 */
(function () {
  'use strict';

  var MERKER_ENTFERNT = 'dmGiftEntfernt';       /* Kunde hat das Geschenk bewusst entfernt (Sitzung) */
  var MERKER_AUTO_GESPERRT = 'dmGiftAutoAus';   /* Automatik gesperrt: Einlegen brachte eine Zeile mit Preis */
  var MERKER_HINWEIS = 'dmGiftHinweis';         /* Hinweistext, der einen Re-Render ueberleben muss */

  var busy = false;              /* laufende Warenkorb-Aenderung durch dieses Skript */
  var pruefungLaeuft = false;    /* Schutz gegen Ueberlappung der Auto-Pruefung */
  var autoVersuche = {};         /* Modus „automatisch": max. 1 Einlege-Versuch je Zustand und Stufe (Schluessel = Stufen-Nummer) */
  var variantenCache = {};       /* handle -> lieferbare Variant-ID (Muster prio-plus.js) */

  /* ---------- kleine Helfer ---------- */

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function rerender(context) {
    if (context === 'cart') {
      window.location.reload();
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  }

  function merkerSetzen(schluessel, wert) {
    try { sessionStorage.setItem(schluessel, wert); } catch (e) { /* Private Mode: dann eben nicht */ }
  }

  function merkerLesen(schluessel) {
    try { return sessionStorage.getItem(schluessel); } catch (e) { return null; }
  }

  function merkerLoeschen(schluessel) {
    try { sessionStorage.removeItem(schluessel); } catch (e) { /* siehe oben */ }
  }

  /* ---------- Konfiguration + Warenkorb-Rechnung ---------- */

  /* Alle gerenderten Bloecke tragen dieselben Werte; fuer den Re-Render-Weg zaehlt aber,
     ob wir auf der Warenkorb-SEITE stehen (dort laedt das Theme neu) — deshalb wird der
     Kontext nicht aus dem ersten gefundenen Block genommen, sondern gesucht. */
  function konfig() {
    var el = document.querySelector('[data-gift-picker]');
    if (!el) return null;
    var seite = document.querySelector('[data-gift-picker][data-context="cart"]');
    return {
      modus: el.getAttribute('data-gift-mode') || 'automatisch',
      /* bereit = Angebot eingeschaltet UND ein Geschenk lieferbar. Ist es das nicht, muss ein
         liegengebliebenes Geschenk trotzdem raus — deshalb rendert der Anker auch dann. */
      bereit: el.getAttribute('data-gift-ready') === 'true',
      /* Angebot eingeschaltet? Unterscheidet „vergriffen" (Block bleibt, Hinweis hat ein Zuhause)
         von „ganz abgeschaltet" (mit der letzten Geschenk-Zeile verschwindet auch der Block). */
      eingeschaltet: el.getAttribute('data-gift-enabled') === 'true',
      schwelle: parseInt(el.getAttribute('data-gift-threshold-cents'), 10) || 0,
      produktTyp: el.getAttribute('data-gift-product-type') || '',
      autoHandle: el.getAttribute('data-gift-auto-handle') || '',
      /* Stufe 2 (PROJ-112): nur wenn Liquid sie als bereit meldet; sonst gibt es genau eine Stufe. */
      stufen: stufenAus(el),
      /* Beigaben (PROJ-112, Dominik 11.10.2026): Geschenkbox zu jeder Kette, Samtsaeckchen zu jedem
         Schluesselanhaenger. Keine Schwelle: liegt das passende Produkt drin, liegt die Beigabe als
         0-EUR-Zeile dabei („Dein Geschenk"), sonst nicht. Preis 0 setzt die Function (Stufe mit Schwelle 0). */
      beigaben: beigabenAus(el),
      context: seite ? 'cart' : 'drawer',
      /* Liquid weiss schon, ob es beim Seitenaufbau etwas zu pruefen gibt (siehe PRUEF-REGEL in
         snippets/gift-picker.liquid). Ohne das laege ein /cart.js pro Seitenansicht an. */
      pruefenNoetig: el.getAttribute('data-gift-check') === 'true',
      entferntText: el.getAttribute('data-gift-removed-text') || '',
      beendetText: el.getAttribute('data-gift-ended-text') || '',
      nichtVerfuegbarText: el.getAttribute('data-gift-unavailable-text') || '',
      fehlerText: el.getAttribute('data-gift-error-text') || ''
    };
  }

  /* Stufen aus dem Anker: Stufe 1 immer, Stufe 2 nur mit Schwelle UND Handle UND bereit. */
  function beigabenAus(el) {
    var liste = [];
    var kette = el.getAttribute('data-gift-beigabe-kette') || '';
    var anhaenger = el.getAttribute('data-gift-beigabe-anhaenger') || '';
    if (kette) liste.push({ art: 'kette', handle: kette });
    if (anhaenger) liste.push({ art: 'anhaenger', handle: anhaenger });
    return liste;
  }

  function istBeigabe(item, k) {
    for (var i = 0; i < k.beigaben.length; i++) if (k.beigaben[i].handle === item.handle) return true;
    return false;
  }

  /* Braucht der Warenkorb diese Beigabe? Kette = Schmuck ohne „anhaenger" im Handle, Anhaenger = Schmuck mit. */
  function brauchtBeigabe(cart, art, k) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (istGeschenk(item, k.produktTyp)) continue;
      if (item.product_type !== 'Schmuck') continue;
      var istAnhaenger = (item.handle || '').indexOf('anhaenger') !== -1;
      if (art === 'anhaenger' && istAnhaenger) return true;
      if (art === 'kette' && !istAnhaenger) return true;
    }
    return false;
  }

  /* Beigaben nacheinander pruefen; true, sobald etwas geaendert wurde (dann endet der Durchlauf,
     das naechste cart:refresh prueft den Rest). */
  function beigabenPruefen(cart, k, beigabenZeilen) {
    var kette = Promise.resolve(false);
    k.beigaben.forEach(function (beigabe) {
      kette = kette.then(function (geaendert) {
        if (geaendert) return true;
        var zeilen = beigabenZeilen.filter(function (z) { return z.handle === beigabe.handle; });
        var bedarf = brauchtBeigabe(cart, beigabe.art, k);
        if (!bedarf && zeilen.length) {
          return zeilenEntfernen(zeilen).then(function (ok) { if (ok) rerender(k.context); return ok; });
        }
        if (zeilen.length > 1) {
          return zeilenEntfernen(zeilen.slice(1)).then(function (ok) { if (ok) rerender(k.context); return ok; });
        }
        if (zeilen.length === 1 && zeilen[0].quantity > 1) {
          return zeileKuerzen(zeilen[0]).then(function (ok) { if (ok) rerender(k.context); return ok; });
        }
        if (zeilen.length === 1 && zeilen[0].final_line_price > 0) {
          /* Function hat nicht gegriffen: raus, und in dieser Sitzung nicht wieder einlegen. */
          autoVersuche['beigabe-' + beigabe.art] = 1;
          return zeilenEntfernen(zeilen).then(function (ok) { if (ok) rerender(k.context); return ok; });
        }
        if (bedarf && !zeilen.length && !autoVersuche['beigabe-' + beigabe.art]) {
          autoVersuche['beigabe-' + beigabe.art] = 1;
          return lieferbareVariante(beigabe.handle).then(function (variantId) {
            if (!variantId) return false;
            return postJSON('/cart/add.js', { items: [{ id: variantId, quantity: 1, properties: { _gratis_geschenk: '1' } }] })
              .then(function (r) { return r.ok; })
              .then(function (ok) { if (ok) rerender(k.context); return ok; });
          });
        }
        return false;
      });
    });
    return kette;
  }

  function stufenAus(el) {
    var stufen = [{
      nummer: 1,
      schwelle: parseInt(el.getAttribute('data-gift-threshold-cents'), 10) || 0,
      handle: el.getAttribute('data-gift-auto-handle') || '',
      modus: el.getAttribute('data-gift-mode') || 'automatisch'
    }];
    var schwelle2 = parseInt(el.getAttribute('data-gift-threshold-2-cents'), 10) || 0;
    var handle2 = el.getAttribute('data-gift-auto-handle-2') || '';
    if (schwelle2 > 0 && handle2 && el.getAttribute('data-gift-ready-2') === 'true') {
      /* Stufe 2 hat ihren eigenen Modus (PROJ-112, Dominik 10.10.2026: Armband automatisch, Spruch-Anhaenger per Auswahl). */
      stufen.push({ nummer: 2, schwelle: schwelle2, handle: handle2, modus: el.getAttribute('data-gift-mode-2') || 'auswahl',
        /* Stufe 2 kann eine Kollektion sein (acht Spruch-Anhaenger als eigene Produkte, 11.10.2026): Liquid liefert
           alle Produkt-Handles der Stufe, damit stufeVon() die Zeilen erkennt. */
        handles: (el.getAttribute('data-gift-handles-2') || handle2).split(',').map(function (h) { return h.trim(); }).filter(Boolean) });
    }
    return stufen;
  }

  /* Stufe einer Geschenk-Zeile: ueber das Produkt-Handle. Unbekanntes Handle = Stufe 1
     (Auswahl-Modus, Altbestand), damit keine Zeile ohne Regeln bleibt. */
  function stufeVon(item, stufen) {
    for (var i = stufen.length - 1; i >= 1; i--) {
      var handles = stufen[i].handles || [stufen[i].handle];
      if (handles.indexOf(item.handle) !== -1) return stufen[i];
    }
    return stufen[0];
  }

  function zeilenDerStufe(geschenke, stufe, stufen) {
    return geschenke.filter(function (zeile) { return stufeVon(zeile, stufen) === stufe; });
  }

  function istGeschenk(item, produktTyp) {
    if (item.properties && item.properties._gratis_geschenk) return true;
    if (produktTyp && item.product_type === produktTyp) return true;
    return false;
  }

  /* Schwellen-Basis: Summe original_line_price (LISTENPREISE) der requires_shipping-Artikel
     OHNE Geschenk-Zeilen — vor Mengenrabatt und vor Rabattcodes. Spiegelt
     snippets/gift-state.liquid und die Function `gratis-geschenk` (cost.subtotalAmount); alle
     drei muessen dieselbe Zahl liefern, sonst zeigt der Balken etwas anderes als das
     Auto-Entfernen tut und als die Kasse berechnet.
     NICHT final_line_price: seit dem Mengenrabatt faellt der bezahlte Betrag unter die Schwelle,
     obwohl der Listenwert darueber liegt — das Geschenk waere sonst still wieder weggeraeumt. */
  function basisBetrag(cart, produktTyp) {
    var summe = 0;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!item.requires_shipping) continue;
      if (istGeschenk(item, produktTyp)) continue;
      summe += item.original_line_price;
    }
    return summe;
  }

  function geschenkZeilen(cart, produktTyp) {
    var treffer = [];
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (istGeschenk(items[i], produktTyp)) treffer.push(items[i]);
    }
    return treffer;
  }

  /* „Bezahlt" heisst: der Shopify-Rabatt hat diese Zeile NICHT auf 0 gesetzt. Das ist die einzige
     ehrliche Quelle — das Theme darf und kann Preise nicht selbst bestimmen. */
  function bezahlteZeilen(zeilen) {
    var treffer = [];
    for (var i = 0; i < zeilen.length; i++) {
      if (zeilen[i].final_line_price > 0) treffer.push(zeilen[i]);
    }
    return treffer;
  }

  /* Ein Warenkorb aus event.detail taugt nur, wenn er wirklich der GANZE Warenkorb ist.
     Zeilen-Felder allein reichen als Nachweis NICHT (Re-Review 11.09.2026):
       * Der Theme-Kern schickt immer eine volle Warenkorb-Antwort — /cart.js bzw. die Antwort
         von /cart/change.js und /cart/update.js (assets/theme.js ~1590, ~2825, ~5398). Die traegt
         item_count und total_price.
       * Die Editor-Skripte (assets/citymap.js, familie.js, collage-poster.js, definitionsposter.js,
         auto-geldgeschenk.js, film-poster.js, ... — 34 Stueck) reichen dagegen die Antwort von
         /cart/add.js durch: { items: [NUR die eben eingelegte Zeile] }. Die Zeile hat key,
         requires_shipping und final_line_price, also haette ein reiner Zeilen-Check gehalten — und
         pruefen() haette auf einem Teil-Warenkorb gerechnet. Folge im Modus „automatisch": das
         schon liegende Geschenk ist im Teil-Cart unsichtbar, Regel 4 legt ein ZWEITES (bezahltes)
         Geschenk ein.
     Deshalb zusaetzlich item_count und total_price verlangen: die hat nur die volle Antwort.
     Fehlt eines, wird frisch geholt statt mit halben Zahlen entschieden.
     Seit die Basis auf original_line_price rechnet (11.09.2026), wird auch dieses Feld verlangt —
     fehlte es, ergaebe die Summe NaN und weder das Auto-Entfernen noch die Automatik wuerden
     greifen (jeder Vergleich mit NaN ist falsch). Lieber einmal nachfetchen. */
  function istVollstaendigerCart(cart) {
    if (!cart || !cart.items || typeof cart.items.length !== 'number') return false;
    if (typeof cart.item_count !== 'number' || typeof cart.total_price !== 'number') return false;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (!item || typeof item.final_line_price !== 'number') return false;
      if (typeof item.original_line_price !== 'number') return false;
      if (typeof item.key !== 'string' || !item.key) return false;
      if (typeof item.requires_shipping !== 'boolean') return false;
    }
    return true;
  }

  /* ---------- Hinweiszeile ---------- */

  /* Reihenfolge ist Absicht: ERST sichtbar machen, DANN den Text schreiben. Wird in eine
     bereits eingeblendete role="status"-Region geschrieben, melden Screenreader die Aenderung
     zuverlaessig; schreibt man in ein noch verstecktes Element, geht die Meldung meist verloren. */
  function hinweisZeigen(text) {
    if (!text) return;
    var ziele = document.querySelectorAll('[data-gift-hinweis]');
    for (var i = 0; i < ziele.length; i++) {
      var block = ziele[i].closest('[data-gift-picker]');
      if (block) block.hidden = false;
      ziele[i].hidden = false;
      ziele[i].textContent = text;
    }
  }

  /* Nach einem Re-Render ist die Hinweiszeile neu (und leer) — der gemerkte Text wird
     genau einmal wieder eingesetzt. */
  function hinweisNachRender() {
    var text = merkerLesen(MERKER_HINWEIS);
    if (!text) return;
    merkerLoeschen(MERKER_HINWEIS);
    hinweisZeigen(text);
  }

  /* ---------- Produkt-Lookup fuer den Modus „automatisch" ---------- */

  function lieferbareVariante(handle) {
    if (!handle) return Promise.resolve(null);
    if (Object.prototype.hasOwnProperty.call(variantenCache, handle)) {
      return Promise.resolve(variantenCache[handle]);
    }
    return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (daten) {
        var id = null;
        var varianten = (daten && daten.variants) || [];
        for (var i = 0; i < varianten.length; i++) {
          if (varianten[i].available) { id = varianten[i].id; break; }
        }
        variantenCache[handle] = id;
        return id;
      })
      .catch(function () { variantenCache[handle] = null; return null; });
  }

  /* ---------- Klicks (delegiert, ueberlebt jeden Drawer-Re-Render) ---------- */

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    /* Kunde entfernt das Geschenk selbst -> in dieser Sitzung nicht erneut einlegen.
       Das Entfernen selbst macht das Theme (line-item-quantity). Der Link-Knopf
       „Geschenk waehlen" ([data-gift-waehlen]) ist ein gewoehnlicher Link zur Kollektion und
       braucht hier nichts. */
    var entfernenLink = e.target.closest('[data-gift-remove]');
    if (entfernenLink) {
      /* Merker je Stufe (PROJ-112): die Zeile traegt ihr Produkt-Handle am Link. */
      var k = konfig();
      var stufe = k ? stufeVon({ handle: entfernenLink.getAttribute('data-gift-handle') || '' }, k.stufen) : null;
      merkerSetzen(stufe ? merkerEntfernt(stufe) : MERKER_ENTFERNT, '1');
    }
  });

  /* ---------- Auto-Pruefung nach jeder Warenkorb-Aenderung ---------- */

  /* Waehrend ein Editor eine Warenkorbzeile ERSETZT (PROJ-99 „Änderung übernehmen"), liegen
     alte und neue Zeile kurz nebeneinander im Warenkorb: erst wird die neue eingelegt, dann die
     alte entfernt (so ist der Warenkorb im Fehlerfall nie leer). Dieser Zwischenstand darf die
     Geschenk-Automatik nicht auslösen — sonst legte sie bei 2 x 45 EUR ein Geschenk ein, das sie
     eine Sekunde spaeter mit dem Hinweis „unter 80 EUR, Geschenk entfernt" wieder abraeumt.
     Erkennbar ist der Modus am Warenkorb-Knopf: cart-edit.js markiert ihn mit
     data-dl-modus="bearbeiten" (knopfAnpassen) und nimmt die Markierung erst beim Beenden des
     Modus wieder weg (knopfFreigeben/modusBeenden) — DANACH feuert der Helfer genau ein
     cart:refresh, und diese Pruefung sieht den endgueltigen Warenkorb. */
  function bearbeitungLaeuft() {
    return !!document.querySelector('[data-dl-modus="bearbeiten"]');
  }

  function pruefen(vorhandenerCart) {
    var k = konfig();
    if (!k || busy || pruefungLaeuft) return;
    if (bearbeitungLaeuft()) return;
    pruefungLaeuft = true;

    /* Liefert das Ereignis den frischen Warenkorb schon mit (theme.js buendelt ihn in
       event.detail.cart), wird er genommen — das spart pro Warenkorb-Aenderung einen Roundtrip.
       Nur wenn er fehlt oder unvollstaendig ist, wird /cart.js geholt. */
    var warenkorbHolen = istVollstaendigerCart(vorhandenerCart)
      ? Promise.resolve(vorhandenerCart)
      : fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });

    warenkorbHolen
      .then(function (cart) {
        var alleGeschenke = geschenkZeilen(cart, k.produktTyp);
        var beigabenZeilen = alleGeschenke.filter(function (z) { return istBeigabe(z, k); });
        var geschenke = alleGeschenke.filter(function (z) { return !istBeigabe(z, k); });
        var basis = basisBetrag(cart, k.produktTyp);
        /* Liegt eine Beigabe drin, hat ihr Einlege-Versuch funktioniert. */
        beigabenZeilen.forEach(function (z) {
          for (var b = 0; b < k.beigaben.length; b++) if (k.beigaben[b].handle === z.handle) delete autoVersuche['beigabe-' + k.beigaben[b].art];
        });

        /* Liegt ein Geschenk drin, hat ein evtl. Einlege-Versuch funktioniert. */
        geschenke.forEach(function (zeile) { delete autoVersuche[stufeVon(zeile, k.stufen).nummer]; });

        /* 0. Angebot aus oder Geschenk vergriffen -> nur die Geschenk-Zeilen raus, die GELD KOSTEN.
              Eine Zeile zu 0,00 EUR haelt der Shopify-Rabatt weiter gratis — solange er laeuft,
              darf der Kunde sie behalten (Betriebsregel im Kopf dieser Datei: erst Theme-Schalter
              aus, dann Rabatt deaktivieren). Weggeraeumt wird nur, was der Kunde sonst bezahlen
              muesste. Der Schwellen-Text waere hier falsch, deshalb ein eigener. */
        if (!k.bereit) {
          var liegengeblieben = bezahlteZeilen(geschenke);
          if (!liegengeblieben.length) return;
          return zeilenEntfernen(liegengeblieben).then(function (ok) {
            if (!ok) return;
            /* Hinweis nur, wenn das Angebot grundsaetzlich laeuft (Bestand leer). Ist es ganz
               abgeschaltet, faellt mit der letzten Geschenk-Zeile auch dieser Block weg — dann
               gaebe es keinen Ort fuer den Hinweis, und ein frei schwebender waere schlechter
               als gar keiner. Eine beendete Aktion muss sich im Warenkorb nicht erklaeren. */
            if (k.eingeschaltet) merkerSetzen(MERKER_HINWEIS, k.beendetText);
            rerender(k.context);
          });
        }

        if (k.schwelle <= 0) return beigabenPruefen(cart, k, beigabenZeilen);

        /* 1 bis 4 je Stufe (PROJ-112). Stufe 1 bleibt im Verhalten wie vor den Stufen, Stufe 2
           bekommt dieselben Regeln mit eigener Schwelle, eigenem Handle und eigenen Merkern. */
        return stufenPruefen(cart, k, geschenke, basis).then(function (geaendert) {
          if (geaendert) return true;
          return beigabenPruefen(cart, k, beigabenZeilen);
        });
      })
      .catch(function () { /* Netzfehler: beim naechsten Warenkorb-Ereignis erneut */ })
      .then(function () { pruefungLaeuft = false; });
  }

  /* Regeln 1 bis 4 je Stufe, in Stufen-Reihenfolge; die erste Aenderung beendet den Durchlauf. */
  function stufenPruefen(cart, k, alleGeschenke, basis) {
    var kette = Promise.resolve(false);
    k.stufen.forEach(function (stufe) {
      kette = kette.then(function (geaendert) {
        if (geaendert) return true;
        return stufeAnwenden(k, stufe, zeilenDerStufe(alleGeschenke, stufe, k.stufen), basis);
      });
    });
    return kette;
  }

  function merkerEntfernt(stufe) { return stufe.nummer === 1 ? MERKER_ENTFERNT : MERKER_ENTFERNT + '-2'; }
  function merkerGesperrt(stufe) { return stufe.nummer === 1 ? MERKER_AUTO_GESPERRT : MERKER_AUTO_GESPERRT + '-2'; }

  /* Liefert ein Promise auf true, wenn etwas geaendert wurde (dann endet der Durchlauf). */
  function stufeAnwenden(k, stufe, geschenke, basis) {
    /* 1. Schwelle unterschritten -> ALLE Geschenk-Zeilen weg, OHNE Hinweistext.
          Gilt auch, wenn nur noch das Geschenk im Warenkorb liegt (Basis 0).
          Dominik 07.10.2026: „Dein Warenkorb liegt unter 85 €, das Gratis-Geschenk wurde entfernt“ soll nicht
          auftauchen, verbraucht unnoetig Platz — der Fortschrittsbalken zeigt den Stand ohnehin. Das Setting
          cart_gift_removed_text bleibt im Schema, wird hier aber bewusst nicht mehr gesetzt. */
    if (geschenke.length > 0 && basis < stufe.schwelle) {
      return zeilenEntfernen(geschenke).then(function (ok) {
        if (!ok) return false;
        rerender(k.context);
        return true;
      });
    }

    /* 2. Mehr als ein Geschenk (Doppelklick, Browser-Zurueck) -> auf EINES reduzieren.
          Stehen bleibt eine GRATIS-Zeile, wenn es eine gibt: Shopify rabattiert nur eine
          Einheit pro Bestellung, die zweite kostet voll (Dev-Test Fall 5). Bliebe stur die
          erste liegen, koennte das die bezahlte sein — Regel 3 muesste sie sofort wieder
          entfernen und der Kunde staende ohne Geschenk da, obwohl eines gratis moeglich war. */
    if (geschenke.length > 1) {
      var behalten = geschenke[0];
      for (var i = 0; i < geschenke.length; i++) {
        if (geschenke[i].final_line_price === 0) { behalten = geschenke[i]; break; }
      }
      var ueberzaehlig = geschenke.filter(function (zeile) { return zeile !== behalten; });
      return zeilenEntfernen(ueberzaehlig).then(function (ok) {
        if (ok) rerender(k.context);
        return ok;
      });
    }

    /* 2b. EINE Geschenk-Zeile, aber Menge > 1 (Review 13.09.2026): ueber die Kollektions- oder
          Produktseite kann der Kunde „2" waehlen. Die Function macht genau EIN Stueck frei, der
          Rest kostet — Regel 3 wuerde die ganze Zeile als „nicht verfuegbar" entfernen, obwohl
          ein Stueck gratis moeglich ist. Deshalb zuerst auf 1 kuerzen; kostet die Zeile danach
          immer noch Geld, greift Regel 3 im naechsten Durchlauf. */
    if (geschenke.length === 1 && geschenke[0].quantity > 1) {
      return zeileKuerzen(geschenke[0]).then(function (ok) {
        if (ok) rerender(k.context);
        return ok;
      });
    }

    /* 3. Schwelle erreicht, die Geschenk-Zeile kostet aber trotzdem Geld -> der Rabatt greift
          nicht (im Admin deaktiviert, ein nicht kombinierbarer Rabattcode liegt im Warenkorb,
          oder das Produkt ist nicht mehr in der Get-Kollektion). Ohne Aufraeumen stuende ein
          „Geschenk" mit vollem Preis und Mengenwaehler im Warenkorb (Review 11.09.2026).
          Nach Regel 2 ist hier hoechstens eine Zeile uebrig. */
    var bezahlte = bezahlteZeilen(geschenke);
    if (bezahlte.length > 0) {
      return zeilenEntfernen(bezahlte).then(function (ok) {
        if (!ok) return false;
        /* Ohne Sperre legte Regel 4 im Automatik-Modus sofort wieder ein: Einlegen,
           entfernen, einlegen — eine Schleife auf Kosten des Kunden. */
        if (stufe.modus === 'automatisch') merkerSetzen(merkerGesperrt(stufe), '1');
        merkerSetzen(MERKER_HINWEIS, k.nichtVerfuegbarText);
        rerender(k.context);
        return true;
      });
    }

    /* 4. Modus „automatisch": ab der Schwelle ohne Klick einlegen — aber nicht, wenn der
          Kunde es in dieser Sitzung bewusst entfernt hat oder die Automatik gesperrt ist,
          und hoechstens ein Versuch, damit ein Fehlschlag keine Reload-Schleife ausloest. */
    if (stufe.modus === 'automatisch'
      && geschenke.length === 0
      && basis >= stufe.schwelle
      && merkerLesen(merkerEntfernt(stufe)) !== '1'
      && merkerLesen(merkerGesperrt(stufe)) !== '1'
      && !autoVersuche[stufe.nummer]) {
      autoVersuche[stufe.nummer] = 1;
      return lieferbareVariante(stufe.handle).then(function (variantId) {
        if (!variantId) return false;
        return postJSON('/cart/add.js', {
          items: [{ id: variantId, quantity: 1, properties: { _gratis_geschenk: '1' } }]
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (antwort) {
            if (!antwort) return false;
            /* /cart/add.js beantwortet ein items-Array mit { items: [eingelegte Zeilen] }.
               Kostet die eingelegte Zeile laut Antwort Geld, hat der Rabatt nicht gegriffen —
               dann sofort zurueckrollen, statt dem Kunden ungefragt einen bezahlten Artikel
               in den Warenkorb zu legen. Sperre + genau ein Hinweis, kein Spam.
               Liefert die Antwort wider Erwarten keine Zeile, wird nur neu gerendert; Regel 3
               raeumt beim naechsten Durchlauf auf. */
            var eingelegt = (antwort.items || [])[0];
            if (eingelegt && eingelegt.final_line_price > 0) {
              merkerSetzen(merkerGesperrt(stufe), '1');
              return postJSON('/cart/change.js', { id: eingelegt.key, quantity: 0 })
                .then(function (r) {
                  /* Erst wenn das Zuruecknehmen wirklich durch ist, darf „wurde entfernt"
                     dastehen. Scheitert es, liegt die bezahlte Zeile noch drin — dann die
                     allgemeine Fehlermeldung; Regel 3 raeumt beim naechsten Ereignis nach.
                     Ein Netzfehler landet im aeusseren catch: kein Hinweis, kein Re-Render,
                     und Regel 3 uebernimmt ebenfalls beim naechsten Ereignis. */
                  merkerSetzen(MERKER_HINWEIS, r.ok ? k.nichtVerfuegbarText : k.fehlerText);
                  rerender(k.context);
                  return true;
                });
            }
            rerender(k.context);
            return true;
          });
      });
    }
    return Promise.resolve(false);
  }

  /* Menge einer Zeile auf 1 setzen (Regel 2b). Gleiches busy-Muster wie zeilenEntfernen. */
  function zeileKuerzen(zeile) {
    busy = true;
    return postJSON('/cart/change.js', { id: zeile.key, quantity: 1 })
      .then(function (r) { busy = false; return r.ok; })
      .catch(function () { busy = false; return false; });
  }

  function zeilenEntfernen(zeilen) {
    if (!zeilen.length) return Promise.resolve(false);
    busy = true;
    var anfrage;
    if (zeilen.length === 1) {
      anfrage = postJSON('/cart/change.js', { id: zeilen[0].key, quantity: 0 });
    } else {
      var updates = {};
      for (var i = 0; i < zeilen.length; i++) updates[zeilen[i].key] = 0;
      anfrage = postJSON('/cart/update.js', { updates: updates });
    }
    return anfrage
      .then(function (r) { busy = false; return r.ok; })
      .catch(function () { busy = false; return false; });
  }

  /* Dieselben Ereignisse wie assets/prio-plus.js. Das Entfernen loest selbst 'cart:refresh'
     aus; beim naechsten Durchlauf ist die Bedingung dann falsch, also endet die Kette.
     WICHTIG: pruefen darf nicht direkt als Handler haengen — das erste Argument waere dann das
     Ereignis und wuerde als „fertiger Warenkorb" missverstanden. */
  document.addEventListener('cart:refresh', function () { pruefen(); });
  document.addEventListener('cart-drawer:refreshed', function () { hinweisNachRender(); pruefen(); });
  document.addEventListener('cart:change', function (event) {
    hinweisNachRender();
    pruefen(event && event.detail ? event.detail.cart : null);
  });

  /* Erst-Pruefung NUR, wenn Liquid sie angefordert hat (data-gift-check). Der Anker liegt im
     Drawer und damit auf jeder Seite — ohne diese Bremse kostete das Angebot einen /cart.js pro
     Seitenansicht fuer jeden Besucher. Der gemerkte Hinweis wird immer eingesetzt, der ueberlebt
     gerade einen Reload auf der Warenkorb-Seite. */
  function startPruefung() {
    hinweisNachRender();
    var k = konfig();
    if (!k || !k.pruefenNoetig) return;
    pruefen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startPruefung);
  } else {
    startPruefung();
  }

  /* ---------- <dm-gift-progress>: Zwei-Stufen-Balken ----------
   * Stufe 1 (Versandkostenfrei) rechnet wie die bestehende FreeShippingBar in
   * assets/theme.js weiter (requires_shipping minus Cart-Level-Rabatte), Stufe 2 (Geschenk)
   * mit der Geschenk-Basis. Die Klasse FreeShippingBar bleibt unberuehrt. */
  var DmGiftProgress = class extends HTMLElement {
    static get observedAttributes() {
      return ['total-price', 'shipping-total-price'];
    }

    connectedCallback() {
      this.aufCartChangeGebunden = this.aufCartChangeGebunden || this.aufCartChange.bind(this);
      document.addEventListener('cart:change', this.aufCartChangeGebunden);
    }

    disconnectedCallback() {
      if (this.aufCartChangeGebunden) document.removeEventListener('cart:change', this.aufCartChangeGebunden);
    }

    attributeChangedCallback() {
      this.zeichnen();
    }

    zahl(name) {
      return parseInt(this.getAttribute(name), 10) || 0;
    }

    betrag(cent) {
      try {
        return new Intl.NumberFormat(window.Shopify && Shopify.locale ? Shopify.locale : 'de', {
          style: 'currency',
          currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'EUR'
        }).format(cent / 100);
      } catch (e) {
        return (cent / 100).toFixed(2);
      }
    }

    aufCartChange(event) {
      var cart = event && event.detail && event.detail.cart;
      if (!cart || !cart.items) return;
      var produktTyp = this.getAttribute('gift-product-type') || '';
      var versandBasis = cart.items
        .filter(function (item) { return item.requires_shipping; })
        .reduce(function (summe, item) { return summe + item.final_line_price; }, 0);
      var cartRabatt = (cart.cart_level_discount_applications || [])
        .reduce(function (summe, d) { return summe + d.total_allocated_amount; }, 0);
      this.setAttribute('shipping-total-price', versandBasis - cartRabatt);
      this.setAttribute('total-price', basisBetrag(cart, produktTyp));
    }

    zeichnen() {
      var versandSchwelle = this.zahl('shipping-threshold');
      var versandBasis = this.zahl('shipping-total-price');
      var geschenkSchwelle = this.zahl('gift-threshold');
      var geschenkBasis = this.zahl('total-price');
      var maximum = this.zahl('bar-max') || Math.max(versandSchwelle, geschenkSchwelle, this.zahl('gift-threshold-2'));

      var versandErreicht = versandBasis >= versandSchwelle;
      var geschenkErreicht = geschenkBasis >= geschenkSchwelle;

      var versandZeile = this.querySelector('[data-gift-progress-shipping]');
      if (versandZeile) {
        if (versandErreicht) {
          versandZeile.innerHTML = this.getAttribute('shipping-reached-message') || '';
        } else {
          var restVersand = this.betrag(versandSchwelle - versandBasis);
          versandZeile.innerHTML = (this.getAttribute('shipping-unreached-message') || '')
            .replace(new RegExp('({{.*}})', 'g'), restVersand);
        }
      }

      /* Stufe 2 (PROJ-112): ist Stufe 1 erreicht, spricht die Zeile ueber Stufe 2. */
      var geschenkSchwelle2 = this.zahl('gift-threshold-2');
      var geschenk2Erreicht = geschenkSchwelle2 > 0 && geschenkBasis >= geschenkSchwelle2;
      var geschenkZeile = this.querySelector('[data-gift-progress-gift]');
      if (geschenkZeile) {
        if (geschenkErreicht && geschenkSchwelle2 > 0) {
          if (geschenk2Erreicht) {
            geschenkZeile.innerHTML = this.getAttribute('gift-reached-message-2') || '';
          } else {
            var restGeschenk2 = this.betrag(geschenkSchwelle2 - geschenkBasis);
            geschenkZeile.innerHTML = (this.getAttribute('gift-unreached-message-2') || '')
              .replace(new RegExp('({{.*}})', 'g'), restGeschenk2);
          }
        } else if (geschenkErreicht) {
          geschenkZeile.innerHTML = this.getAttribute('gift-reached-message') || '';
        } else {
          var restGeschenk = this.betrag(geschenkSchwelle - geschenkBasis);
          geschenkZeile.innerHTML = (this.getAttribute('gift-unreached-message') || '')
            .replace(new RegExp('({{.*}})', 'g'), restGeschenk);
        }
      }

      /* Sichtabnahme Dominik 11.09.2026: immer nur EINE Zeile sichtbar. Solange der Versand
         noch etwas kostet, steht dort der Versand-Text; ab der Versand-Schwelle uebernimmt die
         Geschenk-Stufe. Beide Zeilen bleiben gefuellt (oben), damit ein Wechsel keinen
         Re-Render braucht. Gleiche Regel wie in snippets/free-shipping-bar.liquid. */
      if (versandZeile) versandZeile.hidden = versandErreicht;
      if (geschenkZeile) geschenkZeile.hidden = !versandErreicht;

      /* Wegmarken: erreichte Marke voll, offene gedaempft (Klassenwechsel, kein Re-Render). */
      var versandIcon = this.querySelector('[data-gift-progress-icon-versand]');
      if (versandIcon) {
        versandIcon.classList.toggle('dm-gift-progress__icon--erreicht', versandErreicht);
        if (maximum > 0) {
          versandIcon.style.left = Math.min((versandSchwelle / maximum) * 100, 100) + '%';
        }
      }

      var geschenkIcon = this.querySelector('[data-gift-progress-icon-geschenk]');
      if (geschenkIcon) {
        geschenkIcon.classList.toggle('dm-gift-progress__icon--erreicht', geschenkErreicht);
      }
      var geschenkIcon1 = this.querySelector('[data-gift-progress-icon-geschenk-1]');
      if (geschenkIcon1) {
        geschenkIcon1.classList.toggle('dm-gift-progress__icon--erreicht', geschenkErreicht);
        if (maximum > 0) geschenkIcon1.style.left = Math.min((geschenkSchwelle / maximum) * 100, 100) + '%';
      }
      var geschenkIcon2 = this.querySelector('[data-gift-progress-icon-geschenk-2]');
      if (geschenkIcon2) {
        geschenkIcon2.classList.toggle('dm-gift-progress__icon--erreicht', geschenk2Erreicht);
      }

      var fuellung = this.querySelector('[data-gift-progress-fill]');
      if (fuellung && maximum > 0) {
        fuellung.style.width = Math.min((geschenkBasis / maximum) * 100, 100) + '%';
      }

      var marke = this.querySelector('[data-gift-progress-marker]');
      if (marke && maximum > 0) {
        marke.style.left = Math.min((versandSchwelle / maximum) * 100, 100) + '%';
      }
    }
  };

  if (!window.customElements.get('dm-gift-progress')) {
    window.customElements.define('dm-gift-progress', DmGiftProgress);
  }
})();
